"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImportClient = useImportClient;
const ImportClient_1 = require("@juvare/platform-sdk-js/ImportClient");
const react_1 = __importDefault(require("react"));
function useImportClient(baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new ImportClient_1.ImportClient(baseUrl, tokenProvider), [baseUrl, tokenProvider]);
}
